import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./layouts/layout.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { Page404Component } from "./extrapages/page404/page404.component";
import { UnsubscribeComponent } from "./extrapages/unsubscribe/unsubscribe.component";
import { Box } from "angular-feather/icons";

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./pages/documento-assiantura/documento-assiantura.module").then((m) => m.DocumentoAssianturaModule)
  },
  {
    path: "",
    loadChildren: () =>
      import("./pages/documento-assiantura/documento-assiantura.module").then((m) => m.DocumentoAssianturaModule)
  },
  {
    path: "unsubscribe/:listaDestinatariosId/:tenantId",
    component: UnsubscribeComponent,
  },
  {
    path: "account",
    loadChildren: () =>
      import("./account/account.module").then((m) => m.AccountModule),
  },
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
